import type { MessagePayload } from '@/types/poc/message';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export interface PublishMessageArgs {
  sixId: string;
  topic: string;
  message: MessagePayload;
}

interface PublishMessageResult {
  sixId: string;
  topic: string;
  messageType: MessagePayload['type'];
  timestamp: number;
}

export const publishMessageThunk = createAppAsyncThunk<
  PublishMessageResult,
  PublishMessageArgs
>(
  'messaging/publishMessage',
  async({ sixId, topic, message }, { extra: { pocServices }, rejectWithValue }) => {
    try {
      const libp2pNode = pocServices.p2pStackManagerService.getLibp2pNode(sixId);
      if (libp2pNode === null) {
        throw new Error(`LibP2P node not ready for six '${sixId}'`);
      }

      await pocServices.messagingService.publishMessage(libp2pNode, topic, message);

      return {
        sixId,
        topic,
        messageType: message.type,
        timestamp: Date.now(),
      };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue({ message });
    }
  }
);
